import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/HomePage.vue'),
    meta: {
      title: 'Grupo Babilonia — Teatro, Música y Arte en El Pinar',
      description: 'Grupo Babilonia es una compañía de teatro uruguaya con sede en El Pinar. Descubrí nuestra cartelera, espectáculos y talleres.'
    }
  },
  {
    path: '/cartelera',
    name: 'Cartelera',
    component: () => import('@/views/CarteleraPage.vue'),
    meta: {
      title: 'Cartelera — Grupo Babilonia',
      description: 'Próximas funciones y talleres de Grupo Babilonia. Comprá tus entradas online.'
    }
  },
  {
    path: '/funcion/:slug',
    name: 'Funcion',
    component: () => import('@/views/FuncionPage.vue'),
    meta: {
      title: 'Función — Grupo Babilonia',
      description: 'Información y entradas para esta función de Grupo Babilonia.'
    }
  },
  {
    path: '/el-grupo',
    name: 'ElGrupo',
    component: () => import('@/views/ElGrupoPage.vue'),
    meta: {
      title: 'El Grupo — Grupo Babilonia',
      description: 'Conocé la historia y los integrantes de Grupo Babilonia, compañía de teatro uruguaya fundada en 1994.'
    }
  },
  {
    path: '/galeria',
    name: 'Galeria',
    component: () => import('@/views/GaleriaPage.vue'),
    meta: {
      title: 'Galería — Grupo Babilonia',
      description: 'Galería de fotos de espectáculos y actividades de Grupo Babilonia.'
    }
  },
  {
    path: '/obras',
    name: 'Obras',
    component: () => import('@/views/ObrasPage.vue'),
    meta: {
      title: 'Obras — Grupo Babilonia',
      description: 'Repertorio de obras teatrales de Grupo Babilonia a lo largo de sus 30 años de trayectoria.'
    }
  },
  {
    path: '/talleres/festival',
    name: 'TalleresFestival',
    component: () => import('@/views/TalleresFestivalPage.vue'),
    meta: {
      title: 'Talleres Festival — Grupo Babilonia',
      description: 'Talleres del Festival Arena y Barro de Grupo Babilonia.'
    }
  },
  {
    path: '/talleres/anual',
    name: 'TalleresAnual',
    component: () => import('@/views/TalleresAnualPage.vue'),
    meta: {
      title: 'Taller Anual — Grupo Babilonia',
      description: 'Taller anual de teatro de Grupo Babilonia en El Pinar, Canelones.'
    }
  },
  // ─── Auth ─────────────────────────────
  {
    path: '/login',
    component: () => import('@/views/LoginPage.vue'),
    meta: { title: 'Ingresar — Grupo Babilonia' }
  },
  {
    path: '/activar-cuenta',
    component: () => import('@/views/ActivarCuentaPage.vue'),
    meta: { title: 'Activar cuenta — Grupo Babilonia' }
  },
  {
    path: '/recuperar-contrasena',
    component: () => import('@/views/RecuperarContrasenaPage.vue'),
    meta: { title: 'Recuperar contraseña — Grupo Babilonia' }
  },
  {
    path: '/resetear-contrasena',
    component: () => import('@/views/ResetearContrasenaPage.vue'),
    meta: { title: 'Nueva contraseña — Grupo Babilonia' }
  },
  {
    path: '/mi-cuenta',
    component: () => import('@/views/MiCuentaPage.vue'),
    meta: { title: 'Mi Cuenta — Grupo Babilonia' }
  },
  {
    path: '/mi-perfil',
    component: () => import('@/views/MiPerfilPage.vue'),
    meta: { title: 'Mi Perfil — Grupo Babilonia' }
  },
  {
    path: '/desuscribir',
    component: () => import('@/views/DesuscribirPage.vue'),
    meta: { title: 'Desuscribirse — Grupo Babilonia' }
  },
  // ─── Pagos ────────────────────────────
  {
    path: '/pago/exito',
    name: 'PagoExito',
    component: () => import('@/views/PagoExito.vue'),
    meta: { title: 'Pago confirmado — Grupo Babilonia' }
  },
  {
    path: '/pago/error',
    name: 'PagoError',
    component: () => import('@/views/PagoError.vue'),
    meta: { title: 'Error en el pago — Grupo Babilonia' }
  },
  {
    path: '/pago/pendiente',
    name: 'PagoPendiente',
    component: () => import('@/views/PagoError.vue'),
    meta: { title: 'Pago pendiente — Grupo Babilonia' }
  },
  // ─── Admin ────────────────────────────
  {
    path: '/admin',
    name: 'AdminLogin',
    component: () => import('@/views/AdminLogin.vue'),
    meta: { isAdmin: true }
  },
  {
    path: '/admin/dashboard',
    name: 'AdminDashboard',
    component: () => import('@/views/AdminDashboard.vue'),
    meta: { isAdmin: true }
  },
  {
    path: '/horas',
    name: 'Horas',
    component: () => import('@/views/HorasPage.vue'),
    meta: { isAdmin: true }
  },
  // ─── Boletería ────────────────────────
  {
    path: '/boleteria',
    name: 'Boleteria',
    component: () => import('@/views/BoleteriaPage.vue'),
    meta: { isAdmin: true }
  },
  {
    path: '/boleteria/scanner',
    name: 'BoleteriaScanner',
    component: () => import('@/views/BoleteriaScanner.vue'),
    meta: { isAdmin: true }
  },
  {
    path: '/boleteria/link',
    name: 'BoleteriaLink',
    component: () => import('@/views/BoleteriaLink.vue'),
    meta: { isAdmin: true }
  },
  {
    path: '/boleteria/report',
    name: 'BoleteriaReport',
    component: () => import('@/views/BoleteriaReport.vue'),
    meta: { isAdmin: true }
  },
  {
  path: '/cierre',
  name: 'cierre',
  component: () => import('@/views/CierrePage.vue'),
  meta: { isAdmin: true, title: 'Cierre Babilónico — Grupo Babilonia' },
},
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    } else if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

import { Capacitor } from '@capacitor/core'

router.beforeEach((to, from) => {
  // Native app: redirect / to /login
  if (Capacitor.isNativePlatform() && from.name === undefined && to.path === '/') {
    return '/login'
  }

  // Update document title
  const title = to.meta?.title
  if (title) document.title = title

  // Update meta description
  const description = to.meta?.description
  let metaDesc = document.querySelector('meta[name="description"]')
  if (!metaDesc) {
    metaDesc = document.createElement('meta')
    metaDesc.setAttribute('name', 'description')
    document.head.appendChild(metaDesc)
  }
  if (description) {
    metaDesc.setAttribute('content', description)
  }
})

export default router
